import React from 'react';
import './NavBarPlayList.scss';


function AddPlayList(props) {
    return (
        <div className="nav-bar__play-list__item ">
            <button type="button" className="nav-bar__add-play-list active-link">
                <svg className="nav-bar__play-list__item__icon nav-bar__play-list__item__icon-add" viewBox="0 0 36 36">
                    <path d="m28 20h-8v8h-4v-8h-8v-4h8v-8h4v8h8v4z"></path>
                </svg>
                <span className="nav-bar__play-list__item__title" as="span">Create Playlist</span>
            </button>
        </div>
    );
}

export default AddPlayList;